<template>
	<thead v-bind:class="type">
		<tr>
			<th>
				Full Name
			</th>
			<th>
				Email Address
			</th>
			<th>
				Phone Number
			</th>
			<th v-if="activeColumns.provider">
				Doctor Name
			</th>
			<th v-if="activeColumns.profile">
				Profile
			</th>
			<th>
				Schedule Event
			</th>
			<th>
				Date Of Event
			</th>
		</tr>
	</thead>
</template>
<script>
export default {
	name: 'add-patient-row-head',
	props: ['type', 'active-columns']
}
</script>
<style lang="scss" scoped>
@import "style.scss";
</style>
